// @core/api/endpoints/signature/validate_signature.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateSignatureRequest,
  ValidateSignatureResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Validate signature evidence
 * Independently verifies the content hash, cryptographic signature, certificate chain, and certificate validity.
 */
export async function ValidateSignature(
  signature_id: string,
  data: ValidateSignatureRequest,
  options?: RequestOptions
): Promise<ValidateSignatureResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/signatures/:signature_id/validate`;
  requestPath = requestPath.replace(':signature_id', encodeURIComponent(signature_id));
  const requestOptions = options;
  return client.post<ValidateSignatureResponse>(requestPath, data, requestOptions);
}
